module.exports = __webpack_public_path__ + "assets/algoritmo_desktop_oculto_bacterias.55394f70.svg";